import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import ChargeStationAddView from '../../components/ChargeStationAddView';

function ChargeStationAddScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeStationId = router.query?.chargeStationId;

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách trạm sạc',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: chargeStationId ? 'Sửa trạm sạc' : 'Thêm trạm sạc' },
        ])}
      </div>
      <div className="my-4">
        <ChargeStationAddView chargeStationId={chargeStationId} />
      </div>
    </div>
  );
}

export default ChargeStationAddScreen;
